import { hasApiMenuPermission } from '@/libs/permissions';

// 通过 computed 计算属性，获取权限
// 当前模块使用过的权限，全部集中在这里，方便查看和维护
export default {
  computed: {
    // 权限 - 文档 - 首页
    AUTH_DOCS() {
      return hasApiMenuPermission('and', ['auth_docs', 'auth_docs_home_list_all']);
    },

    // 权限 - 文档 - 搜索
    AUTH_DOCS_SEARCH() {
      return hasApiMenuPermission('and', ['auth_docs_category_list', 'auth_docs_search']);
    },

    // 权限 - 文档 - 详情
    AUTH_DOCS_DETAIL() {
      return hasApiMenuPermission('and', ['auth_docs_detail']);
    },

    // 权限 - 文档 - 详情
    AUTH_DOCS_DETAIL_TYPE() {
      return hasApiMenuPermission('and', ['auth_docs_detail_type']);
    },

    // 权限 - 文档 - 管理
    AUTH_DOCS_MANAGE() {
      return hasApiMenuPermission('and', ['auth_docs', 'auth_docs_manage']);
    },

    // 权限 - 文档 - 添加
    AUTH_DOCS_ADD() {
      return hasApiMenuPermission('and', ['auth_docs_add']);
    },

    // 权限 - 文档 - 编辑
    AUTH_DOCS_EDIT() {
      return hasApiMenuPermission('and', ['auth_docs_edit']);
    },

    // 权限 - 文档 - 删除
    AUTH_DOCS_DELETE() {
      return hasApiMenuPermission('and', ['auth_docs_delete']);
    },

    // 权限 - 文档 - 内容编辑
    AUTH_DOCS_CONTENT_EDIT() {
      return hasApiMenuPermission('and', ['auth_docs_content_edit']);
    },

    // 权限 - 文档 - 禁用/启用
    AUTH_DOCS_ENABLE_DISABLE() {
      return hasApiMenuPermission('and', ['auth_docs_enable_disable']);
    },

    // 权限 - 文档 - 分类管理
    AUTH_DOCS_CATEGORY_MANAGE() {
      return hasApiMenuPermission('and', ['auth_docs_category_manage']);
    },

    // 权限 - 文档 - 分类添加
    AUTH_DOCS_CATEGORY_ADD() {
      return hasApiMenuPermission('and', ['auth_docs_category_add']);
    },

    // 权限 - 文档 - 分类编辑
    AUTH_DOCS_CATEGORY_EDIT() {
      return hasApiMenuPermission('and', ['auth_docs_category_edit']);
    },

    // 权限 - 文档 - 分类删除
    AUTH_DOCS_CATEGORY_DELETE() {
      return hasApiMenuPermission('and', ['auth_docs_category_delete']);
    },
  },
};
